import produce from "immer";

import {
  QUIZ3_DATA_WATCH,
  QUIZ3_DATA_UPDATE,
  QUIZ3_META_WATCH
} from "../actions/types";

const initialState = {
  data: null,
  meta: null
};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case QUIZ3_DATA_WATCH:
        draft.data = action.payload.data;
        break;
      case QUIZ3_META_WATCH:
        draft.meta = action.payload.meta;
        break;
      case QUIZ3_DATA_UPDATE:
        console.log("no reducer update");
        break;
    }
  });
};
